import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FlavoristIcon from "../../../Assets/images/Flavorist Logo.jpg";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import { Avatar, Button, Modal, Typography } from "antd";

const { Text } = Typography;
const Breadcrumb = () => {
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);
    const handleLogout = () => {
    setIsModalVisible(true);
  };

  const handleConfirmLogout = () => {
    Cookies.remove("authToken");
    localStorage.clear();
    navigate("/login");
  };

  const userName = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  const formatText = (text) => {
    return text
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="breadcrumb flex-center-between">
      <div className="breadcrumb-logo flex-center">
        <img src={FlavoristIcon} alt="Flavorist logo" />
      </div>

      <div className="flex-center-betweeen breadcrumb-right-side">
        <Avatar
          size={40}
          src="htle.com/path/to/image.jpg"
          icon={<UserOutlined />}
        />
        <div className="admin-name-role">
          <div className="admin-name">{userName}</div>
          <div className="admin-role">{formatText(role)}</div>
        </div>
        <Button
          style={{ color: "unset", background: "unset" }}
          type="primary"
          onClick={handleLogout}
        >
          <LogoutOutlined />
        </Button>
      </div>

      <Modal
        title="Confirm Logout"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        centered
        footer={[
          <Button key="cancel" onClick={() => setIsModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="logout"
            type="primary"
            danger
            onClick={handleConfirmLogout}
          >
            Logout
          </Button>,
        ]}
      >
        <Text>Are you sure you want to log out?</Text>
      </Modal>
    </div>
  );
};

export default Breadcrumb;
